import { jsx as a } from "react/jsx-runtime";
import { ModalManager as m } from "./index.es97.js";
import { Modal as n } from "./index.es94.js";
import { ConfirmationDialogBox as t } from "./index.es96.js";
import { DynamicContainer as e } from "./index.es517.js";
const c = () => {
  var r;
  const o = (r = m) == null ? void 0 : r.getInstance();
  return /* @__PURE__ */ a(
    e,
    {
      manager: o,
      componentMap: {
        confirmation: t,
        "modal-template": n
      },
      removeItem: o.removeModal
    }
  );
};
export {
  c as ModalsContainer
};
//# sourceMappingURL=index.es98.js.map
